import React from "react";
import { FeatherAlertCircle } from "@subframe/core";
import { VendorExpenseCategoryDetails } from "../../services/api";

interface VendorPaymentExpenseRecoViewProps {
  details: VendorExpenseCategoryDetails | null;
  isLoading?: boolean;
}

const VendorPaymentExpenseRecoView: React.FC<
  VendorPaymentExpenseRecoViewProps
> = ({ details, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center rounded-md border border-dashed border-neutral-border bg-neutral-50 px-6 py-10 text-body text-subtext-color">
        Loading expense details...
      </div>
    );
  }

  if (!details) {
    return (
      <div className="flex w-full flex-col items-center gap-2 rounded-md border border-dashed border-neutral-border bg-neutral-50 px-6 py-10 text-center text-body text-subtext-color">
        <FeatherAlertCircle className="text-neutral-400" />
        <span>Expense details are not available for this transaction.</span>
      </div>
    );
  }

  const currencySymbol =
    details.currency_symbol || details.currency_code || "₹";

  return (
    <div className="flex w-full flex-col gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
      <div className="flex flex-col gap-1">
        <span className="text-heading-3 font-heading-3 text-default-font">
          Expense
        </span>
      </div>

      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
        <div className="flex flex-col rounded-md border border-dashed border-neutral-border px-4 py-3">
          <span className="text-caption text-subtext-color">GL Account</span>
          <span className="text-heading-4 font-heading-4 text-default-font">
            {details.gl_name || details.account_id}
          </span>
        </div>
        <div className="flex flex-col rounded-md border border-dashed border-neutral-border px-4 py-3">
          <span className="text-caption text-subtext-color">Paid Through</span>
          <span className="text-heading-4 font-heading-4 text-default-font">
            {details.paid_through_account_name ||
              details.paid_through_account_id ||
              "—"}
          </span>
        </div>
        <div className="flex flex-col rounded-md border border-dashed border-neutral-border px-4 py-3">
          <span className="text-caption text-subtext-color">Date</span>
          <span className="text-heading-4 font-heading-4 text-default-font">
            {details.date ? new Date(details.date).toLocaleDateString() : "—"}
          </span>
        </div>
        <div className="flex flex-col rounded-md border border-dashed border-neutral-border px-4 py-3">
          <span className="text-caption text-subtext-color">Amount</span>
          <span className="text-heading-4 font-heading-4 text-default-font">
            {currencySymbol} {details.amount.toLocaleString("en-IN")}
          </span>
        </div>
      </div>

      {details.notes && (
        <div className="flex flex-col rounded-md border border-dashed border-neutral-border px-4 py-3">
          <span className="text-caption text-subtext-color">Notes</span>
          <span className="text-body text-default-font">{details.notes}</span>
        </div>
      )}
    </div>
  );
};

export default VendorPaymentExpenseRecoView;
